import React from 'react';
import ResultsHero from '../components/results/ResultsHero';
import Gallery from '../components/results/Gallery';
import Testimonials from '../components/results/Testimonials';

const Results: React.FC = () => {
  return (
    <div className="bg-light">
      {/* Novo hero com animações e layout interativo */}
      <ResultsHero />

      {/* Âncora para scroll suave do CTA do hero */}
      <div id="galeria-cases" className="h-0" />

      {/* Galeria e depoimentos */}
      <Gallery />
      <Testimonials />
    </div>
  );
};

export default Results;